import React, { useState } from "react";
import { motion } from "framer-motion";
import { Rocket } from "lucide-react";
import { DealsRequest } from "../../requests/vendor/DealsRequest";
import { toast } from "react-toastify";

const PromoteDealModal = ({ setPromoteModal, dealSlug, promoteModal, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = () => {
    setPromoteModal({ isOpen: false, deal_slug: null });
  };

  const handlePromote = async () => {
    try {
      setIsLoading(true);
      await DealsRequest.promoteDeal(promoteModal.deal_slug);
      toast.success("Deal promoted successfully!");
      
      if (onSuccess) {
        await onSuccess();
      }
      
      handleClose();
    } catch (error) {
      toast.error(error.message || "Failed to promote deal. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {promoteModal?.isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="flex fixed inset-0 z-50 justify-center items-center backdrop-blur-sm bg-black/50"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative p-6 w-full max-w-md bg-white rounded-2xl shadow-xl"
          >
            <motion.div
              initial={{ rotate: 10, scale: 0 }}
              animate={{ rotate: 0, scale: 1 }}
              transition={{ type: "spring", duration: 0.5 }}
              className="flex justify-center mb-4"
            >
              <div className="p-3 bg-blue-100 rounded-full">
                <Rocket size={32} className="text-blue-500" />
              </div>
            </motion.div>

            <motion.div
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 }}
              className="mb-6 text-center"
            >
              <h3 className="mb-2 text-lg font-semibold text-gray-900">
                Boost Your Deal's Visibility
              </h3>
              <p className="text-sm text-gray-500">
                Ready to get more eyes on your deal? Promoting your deal will increase its visibility and help it reach more potential customers.
              </p>
            </motion.div>

            <motion.div
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="flex flex-col gap-2 sm:flex-row sm:gap-3"
            >
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleClose}
                className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                Not Now
              </motion.button>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handlePromote}
                disabled={isLoading}
                className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-blue-300 disabled:opacity-50"
              >
                {isLoading ? (
                  <div className="flex justify-center items-center">
                    <div className="w-5 h-5 rounded-full border-2 border-white animate-spin border-t-transparent" />
                  </div>
                ) : (
                  "Promote Deal"
                )}
              </motion.button>
            </motion.div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
};

export default PromoteDealModal;
